/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('InstructorDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		InstructorFactory,
		AlertService,
		NoPagingInstructorFactory,
		RelationFactory,
		NoPagingRelationFactory,
		AutocompleteRelationsByQueryParamsFactory,
		EventFactory,
		NoPagingEventFactory,
		AutocompleteEventsByQueryParamsFactory,
		NoPagingArticleFactory,
		NoPagingSubscriptionStatusFactory,
		InstructorFindArticleFilteredByHotelFactory
	) {
		$scope.instructor = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return $rootScope.isDefinedAndNotNull($scope.instructor) && $rootScope.isDefinedAndNotNull($scope.instructor.id);
		};

		$scope.createRelation = function() {
			var referredBy = {
				refName: 'relation',
				data: $scope.instructor,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new relation will add this new instructor state to the history stack
				$state.go('instructor.list.newRelation', { referredBy: referredBy }, { reload: false });
			}, 100);
		};
		$scope.createStatus = function() {
			var referredBy = {
				refName: 'status',
				data: $scope.instructor,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new status will add this new instructor state to the history stack
				$state.go('instructor.list.newSubscriptionStatus', { referredBy: referredBy }, { reload: false });
			}, 100);
		};

		$scope.submitButtonIsActive = true;

		$scope.autocompleteRelations = function(val) {
			var params = {
				relationTypeAheadSearchString: val,
			};

			return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};
		$scope.autocompleteEvents = function(val) {
			var params = {
				eventTypeAheadSearchString: val,
			};

			return AutocompleteEventsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('instructor.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		/**
		 * This function preselects and disables the parent reference in autocomplete field when called from tab
		 */
		$scope.queryRelation = function() {
			// If the id of a preselected relation is available, then retrieve from backend and set in model
			if ($stateParams.mappedById === null) {
				return null;
			} else {
				return RelationFactory.get({ id: $stateParams.mappedById }, function(result) {
					if (result !== null) {
						$scope.findItemByParent([result], 'relation');
					}
				});
			}
		};
		$scope.relationList = $scope.queryRelation();

		/**
		 * This function preselects and disables the parent reference in autocomplete field when called from tab
		 */
		$scope.queryEvent = function() {
			// If the id of a preselected event is available, then retrieve from backend and set in model
			if ($stateParams.mappedById === null) {
				return null;
			} else {
				return EventFactory.get({ id: $stateParams.mappedById }, function(result) {
					if (result !== null) {
						$scope.findItemByParent([result], 'event');
					}
				});
			}
		};
		$scope.eventList = $scope.queryEvent();

		// --- start default implementation
		/**
		 * This function queries all entities of type Hotel and checks if this Instructor dialog is called in the context of Hotel.
		 * If this is the case, we detect the parent entity Instructor and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryHotel = function() {
			return InstructorFindArticleFilteredByHotelFactory.query(function(result) {
				$scope.findItemByParent(result, 'hotel');
			});
		};
		$scope.hotelList = $scope.queryHotel();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type Status and checks if this Instructor dialog is called in the context of Status.
		 * If this is the case, we detect the parent entity Instructor and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryStatus = function() {
			return NoPagingSubscriptionStatusFactory.query(function(result) {
				$scope.findItemByParent(result, 'status');
			});
		};
		$scope.statusList = $scope.queryStatus();
		// --- end default implementation

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:instructorUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving Instructor failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			//check for autocomplete reference. When backspaced the reference equals an empty string, which should be converted into null before posting
			if ($scope.instructor.relation === '') {
				$scope.instructor.relation = null;
			}
			//check for autocomplete reference. When backspaced the reference equals an empty string, which should be converted into null before posting
			if ($scope.instructor.event === '') {
				$scope.instructor.event = null;
			}

			if ($scope.instructor.id != null) {
				InstructorFactory.update($scope.instructor, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				InstructorFactory.save($scope.instructor, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});
